var React = require('react');

function TwitterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"twitter-icon__path","d":"M125.8,362.5c150.9,0,233.5-125.1,233.5-233.5c0-3.6,0-7.1-0.2-10.6c16.1-11.6,29.9-26,40.9-42.5c-15,6.6-30.9,11-47.1,12.9\n\tc17.1-10.3,30-26.4,36.1-45.4c-16.1,9.6-33.7,16.3-52.1,19.9c-31.1-33-83.1-34.6-116.1-3.6c-21.3,20-30.4,49.9-23.7,78.4\n\tc-66-3.3-127.5-34.5-169.1-85.7C6.1,90,17.2,137.9,53.2,162c-13.1-0.4-25.8-3.9-37.2-10.3c0,0.3,0,0.7,0,1\n\tc0,39.1,27.5,72.7,65.8,80.4c-12.1,3.3-24.8,3.8-37.1,1.4c10.8,33.4,41.6,56.3,76.7,57c-29.1,22.8-65,35.2-101.9,35.2\n\tc-6.5,0-13.1-0.4-19.5-1.2C37.5,349.7,81.2,362.5,125.8,362.5"}));
}

TwitterIcon.defaultProps = {"id":"twitter-icon","className":"twitter-icon","x":"0px","y":"0px","viewBox":"0 0 400 400","style":{"enableBackground":"new 0 0 400 400"},"xmlSpace":"preserve"};

module.exports = TwitterIcon;

TwitterIcon.default = TwitterIcon;
